export const ENDPOINTS = {
  get_mentors: "mentors/",
};